import { supabase } from "@/integrations/supabase/client";

export type BrandingProfile = {
  id: string;
  slug: string;
  school_name: string;
  principal_name: string | null;
  academic_year: string | null;
  tagline: string | null;
  logo_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  accent_color: string | null;
  is_active: boolean;
};

export const WEKIT_DEFAULTS = {
  primary: "#00665B",
  secondary: "#0818A8",
  accent: "#FF5F1F",
  // Default tenant identity used as the LAST-RESORT fallback only. Every
  // principal/admin surface should prefer the resolved org name or active
  // demo branding profile before falling back to this constant.
  school_name: "WeKIT Demo School",
  tagline: "Rooting YOU in YOUR Purpose",
};

export async function fetchActiveBranding(): Promise<BrandingProfile | null> {
  const { data } = await (supabase as any)
    .from("demo_branding_profiles")
    .select("*")
    .eq("is_active", true)
    .maybeSingle();
  return data ?? null;
}

export async function listBrandingProfiles(): Promise<BrandingProfile[]> {
  const { data } = await (supabase as any)
    .from("demo_branding_profiles")
    .select("*")
    .order("updated_at", { ascending: false });
  return (data ?? []) as BrandingProfile[];
}
